import { Box } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { MarkdownView } from 'src/common/components/markdown-editor/MarkdownView';
import { ThinkingTile } from './ThinkingTile';

type Props = {
  content: string;
  thinkingContent?: string;
};

export function SiestaMessage({ content, thinkingContent }: Props) {
  return (
    <Box>
      {thinkingContent && <ThinkingTile content={thinkingContent} />}
      <Box fz="var(--mantine-font-size-textSm)" fw={FONT_WEIGHTS.medium} c="gray.8">
        <MarkdownView value={content} />
      </Box>
    </Box>
  );
}
